/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfixstep33Inputs */

const en_crosspostinghelpfixstep33 = /** @type {(inputs: Crosspostinghelpfixstep33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still failing? Reconnect and try the other login option (business login) - Pages owned by a Business Portfolio often only appear that way.`)
};

const de_crosspostinghelpfixstep33 = /** @type {(inputs: Crosspostinghelpfixstep33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klappt es immer noch nicht? Neu verbinden und die andere Anmeldeoption (Business-Login von Meta) probieren – Seiten aus einem Business-Portfolio erscheinen oft nur so.`)
};

/**
* | output |
* | --- |
* | "Still failing? Reconnect and try the other login option (business login) - Pages owned by a Business Portfolio often only appear that way." |
*
* @param {Crosspostinghelpfixstep33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfixstep33 = /** @type {((inputs?: Crosspostinghelpfixstep33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfixstep33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfixstep33(inputs)
	return de_crosspostinghelpfixstep33(inputs)
});
export { crosspostinghelpfixstep33 as "crosspostingHelpFixStep3" }